import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuditHistoryService } from '../../services/audit-history.service';
import { OrdersAuditOp, SolutionEstimateAuditOp, ordersKeys, ordersTableField, reportsField } from '../../../main/content/apps/utils';
import { environment } from '../../../../environments/environment';
import { OrderStatus } from '../../../main/content/apps/e-commerce/orders/orders.service';
import { CommonOrdersService } from '../../../main/content/apps/e-commerce/orders/commonOrders.service';

@Component({
  selector: 'order-view-logs',
  templateUrl: './order-view-logs.component.html',
  styleUrls: ['./order-view-logs.component.scss']
})
export class OrderViewLogsDialogComponent {

  userRole;
  allStatus: OrderStatus[];
  roles = [];
  auditLogData: any = [];
  ordersKeys = ordersKeys;
  SolutionEstimateAuditOp = SolutionEstimateAuditOp;
  ordersTableField = ordersTableField;
  auditLoader = true;
  reportsField = reportsField
  constructor(
    public dialogRef: MatDialogRef<OrderViewLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public auditHistoryService: AuditHistoryService,
    public commonOrdersService: CommonOrdersService,
  ) {
    this.userRole = window.localStorage.getItem('role');
  }

  ngOnInit() {
    this.getAllStatus();
    this.fetchAuditLogsByOrderId();
  }

  fetchAuditLogsByOrderId() {
    this.auditHistoryService.fetchLogsByOrderId(this.data.orderId, OrdersAuditOp).then((auditLogRes: any) => {
      this.auditHistoryService.formatAuditLogData(auditLogRes).then((formatRes) => {
        this.formatNewDataArray(formatRes).then((formatArray) => {
          this.auditLogData = formatArray;
          this.auditLoader = false;
        });


      })

    }).catch((auditLogErr) => {
      console.log("auditLogErr", auditLogErr);
      this.auditLoader = false;
    });
  }

  formatNewDataArray(auditNewData) {

    return new Promise((resolve, reject) => {
      for (let z = 0; z < auditNewData.length; z++) {
        let newDataFormat = [];
        let oldDataFormat = [];
        let newDataArray = auditNewData.length > 0 && auditNewData[z].newData ? auditNewData[z].newData : [];
        let oldDataArray = auditNewData.length > 0 && auditNewData[z].oldData ? auditNewData[z].oldData : [];
        for (let i = 0; i < newDataArray.length; i++) {
          if (newDataArray[i].value && !ordersTableField.includes(newDataArray[i].key) && newDataArray[i].value !== "now()"
            && newDataArray[i].key !== "orderContent" && newDataArray[i].key !== "city" && newDataArray[i].key !== "state"
            && newDataArray[i].key !== "postcode") {
            if (newDataArray[i].value && newDataArray[i].value.toString().includes(environment.apiHost)) {
              let data = {
                key: newDataArray[i].key,
                value: newDataArray[i].value.split("/")[6]
              }
              newDataFormat.push(data);

            } else {
              newDataFormat.push(newDataArray[i]);
            }
          }
        }

        for (let i = 0; i < oldDataArray.length; i++) {
          if (oldDataArray[i].value && !ordersTableField.includes(oldDataArray[i].key) && oldDataArray[i].value !== "now()"
            && oldDataArray[i].key !== "orderContent" && oldDataArray[i].key !== "city" && oldDataArray[i].key !== "state"
            && oldDataArray[i].key !== "postcode") {
            if (oldDataArray[i].value && oldDataArray[i].value.toString().includes(environment.apiHost)) {
              let data = {
                key: oldDataArray[i].key,
                value: oldDataArray[i].value.split("/")[6]
              }
              oldDataFormat.push(data);

            } else {
              oldDataFormat.push(oldDataArray[i]);
            }
          }
        }

        if (auditNewData.length > 0) {
          auditNewData[z]['newData'] = [...newDataFormat];
          auditNewData[z]['oldData'] = [...oldDataFormat];
        }
        else {
          auditNewData = [...auditNewData];
        }
      }
      resolve(auditNewData)
    });
  }

  getAllStatus() {
    this.commonOrdersService.listOfStatusAll.subscribe((statusRes) => {
      this.allStatus = statusRes.length > 0 ? statusRes : [];
    });
  }

  getStatusName(data) {
    if (data && data.length > 0 && data[0].value) {
      let status = this.allStatus.find(type => type.statusId === data[0].value);
      return status && status['displayStatus'] ? status['displayStatus'] : '';
    }
    else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/core/components/order-view-logs/order-view-logs.component.ts